<template>
  <div class="manage-opening container py-5">
    <h2 class="mb-4">Gestion de la permanence</h2>

    <b-card class="mb-4">
      <div
        v-b-toggle.opening-params
        class="d-flex align-items-center justify-content-between collapse-toggle"
      >
        <h4 class="mb-0">Paramètres de la permanence</h4>
        <b-icon icon="chevron-down" class="collapse-chevron"></b-icon>
      </div>
      <b-collapse id="opening-params">
        <b-form @submit.prevent="openConfirmModal">
        <!---
        <b-form-group label="Titre (optionnel)">
          <b-form-input
            v-model="editForm.title"
            placeholder="Ex. : séance libre, entraînement, etc."
          ></b-form-input>
        </b-form-group>
        -->

        <b-form-group label="Description">
          <b-form-textarea
            v-model="editForm.description"
            rows="3"
            placeholder="Details sur l'ouverture"
          />
        </b-form-group>

        <b-form-group label="Events (min. 2)">
          <div
            v-for="(event, index) in editForm.events"
            :key="event._id || event._localKey"
            class="mb-2 event-row"
          >
            <div class="d-flex align-items-center">
              <HourMinutePicker
                v-model="event.time"
                class="mr-2 manage-event-time-input"
                :disabled="!canCurrentUserEditEvent(event)"
              />
              <b-form-select
                v-model="event.type"
                :options="eventTypes"
                class="mr-2 manage-event-type-input"
                :disabled="!canCurrentUserEditEvent(event)"
              ></b-form-select>
              <b-button
                v-if="canCurrentUserEditEvent(event)"
                variant="outline-danger"
                :disabled="editForm.events.length <= 2"
                title="Supprimer"
                @click="removeEvent(index)"
              >
                <b-icon icon="trash"></b-icon>
              </b-button>
              <small v-else class="text-muted mr-2">
                de {{ getEventCreatorLabel(event) }}
              </small>
            </div>
          </div>
          <b-button variant="outline-primary" size="sm" @click="addEvent">
            + Ajouter un event
          </b-button>
        </b-form-group>

          <div class="text-right">
            <b-button type="submit" variant="primary">
              Enregistrer
            </b-button>
          </div>
        </b-form>
      </b-collapse>
    </b-card>

    <b-modal
      :visible="confirmModalVisible"
      title="Confirmer les modifications"
      @update:visible="confirmModalVisible = $event"
      centered
    >
      <p class="mb-0">
        Tous les inscrits seront alertes par mail des changements.
      </p>
      <template #modal-footer>
        <b-button variant="secondary" @click="confirmModalVisible = false">
          Annuler
        </b-button>
        <b-button variant="primary" @click="updateOpeningInfo()">
          Confirmer
        </b-button>
      </template>
    </b-modal>

    <b-card class="mb-4">
      <div
        v-b-toggle.opening-create-user
        class="d-flex align-items-center justify-content-between collapse-toggle"
      >
        <h4 class="mb-0">Créer un compte utilisateur</h4>
        <b-icon icon="chevron-down" class="collapse-chevron"></b-icon>
      </div>
      <b-collapse id="opening-create-user">
        <b-form @submit.prevent="createUserAccount">
          <p class="text-muted small mb-3">
            <span class="required-asterisk">*</span> Champs obligatoires
          </p>


          <h5 class="section-title">Identite</h5>
          <b-row>
            <b-col md="6">
              <b-form-group>
                <template #label>
                  Prenom <span class="required-asterisk">*</span>
                </template>
                <b-form-input
                  v-model="addUserForm.create.name"
                  placeholder="ex: Jean"
                  required
                />
              </b-form-group>
            </b-col>
            <b-col md="6">
              <b-form-group>
                <template #label>
                  Nom de famille <span class="required-asterisk">*</span>
                </template>
                <b-form-input
                  v-model="addUserForm.create.surname"
                  placeholder="ex: Dupont"
                  required
                />
              </b-form-group>
            </b-col>
          </b-row>

          <b-row>
            <b-col md="6">
              <b-form-group>
                <template #label>
                  Date de naissance <span class="required-asterisk">*</span>
                </template>
                <b-form-input
                  v-model="addUserForm.create.bornAt"
                  type="date"
                  required
                />
              </b-form-group>
            </b-col>
            <b-col md="6">
              <b-form-group>
                <template #label>
                  Genre <span class="required-asterisk">*</span>
                </template>
                <b-form-select
                  v-model="addUserForm.create.gender"
                  :options="genderOptions"
                  required
                />
              </b-form-group>
            </b-col>
          </b-row>

          <hr class="section-divider">
          <h5 class="section-title">Coordonnees</h5>
          <b-row>
            <b-col md="6">
              <b-form-group>
                <template #label>
                  Numero de telephone <span class="required-asterisk">*</span>
                </template>
                <b-form-input
                  v-model="addUserForm.create.phoneNumber"
                  placeholder="ex: 06 12 34 56 78"
                  required
                />
              </b-form-group>
            </b-col>
            <b-col md="6">
              <b-form-group>
                <template #label>
                  Adresse e-mail <span class="required-asterisk">*</span>
                </template>
                <b-form-input
                  v-model="addUserForm.create.email"
                  type="email"
                  placeholder="ex: jean@example.com"
                  required
                />
              </b-form-group>
            </b-col>
          </b-row>

          <hr class="section-divider">
          <h5 class="section-title">Consentements</h5>
          <b-form-group>
            <b-form-checkbox v-model="addUserForm.create.newsletter">
              L'utilisateur souhaite recevoir la newsletter occasionnelle.
            </b-form-checkbox>
          </b-form-group>

          <b-form-group>
            <b-form-checkbox v-model="addUserForm.create.photoConsent">
              L'utilisateur accepte d'etre filme ou photographie par le GUC Voile.
            </b-form-checkbox>
          </b-form-group>

          <b-form-group>
            <b-form-checkbox v-model="addUserForm.create.swimmingConsent">
              L'utilisateur declare etre apte a plonger et nager 50 metres.
            </b-form-checkbox>
          </b-form-group>

          <b-form-group>
            <b-form-checkbox v-model="addUserForm.create.reglementConsent" required>
              L'utilisateur a lu et accepte le
              <a :href="reglementUrl" target="_blank" download="reglement-guc-voile.pdf">reglement du GUC Voile.</a>
              <span class="required-asterisk">*</span>
            </b-form-checkbox>
          </b-form-group>

          <div class="text-right">
            <b-button type="submit" variant="primary" :disabled="!canCreateUser || addUserCreateLoading">
              <b-spinner v-if="addUserCreateLoading" small class="mr-2"></b-spinner>
              Créer le compte
            </b-button>
          </div>
        </b-form>
      </b-collapse>
    </b-card>

    <b-card class="mb-4">
      <div
        v-b-toggle.opening-add-user
        class="d-flex align-items-center justify-content-between collapse-toggle"
      >
        <h4 class="mb-0">Ajouter un utilisateur</h4>
        <b-icon icon="chevron-down" class="collapse-chevron"></b-icon>
      </div>
      <b-collapse id="opening-add-user" visible>
        <b-form @submit.prevent="addParticipant">

          <div class="form-section">
            <div class="form-section-heading">
              <b-icon icon="person-badge-fill" class="form-section-heading__icon" scale="0.6" />
              <span>Utilisateur</span>
            </div>
            <b-form-group class="mb-0">
              <UserSearchSelect
                v-if="!addUserForm.selectedUser"
                :value="addUserForm.selectedUser"
                placeholder="Nom, prenom ou email"
                no-results-text="Aucun utilisateur ne correspond a cette recherche."
                :disabled="addUserLoading"
                @selected="handleAddUserSelected"
              />
              <div
                v-if="addUserForm.selectedUser"
                class="selected-user-card"
              >
                <div class="selected-user-card__avatar">
                  <b-icon icon="person-fill" scale="0.85" />
                </div>
                <div class="flex-grow-1">
                  <div class="font-weight-bold">{{ addUserForm.selectedUser.name }}</div>
                  <small class="text-muted">{{ addUserForm.selectedUser.email }}</small>
                </div>
                <b-button size="sm" variant="outline-danger" @click="removeSelectedUser()">
                  Retirer
                </b-button>
              </div>
            </b-form-group>
          </div>


          <template v-if="addUserForm.selectedUser">
            <div class="form-section">
            <div class="form-section-heading">
              <b-icon icon="patch-check-fill" class="form-section-heading__icon" scale="0.6" />
              <span>Adhésion</span>
            </div>
            <b-card v-if="addUserForm.hasValidAdhesion" class="bg-success text-white border-0 mb-3">
              <div class="font-weight-bold d-flex align-items-center">
                <b-icon icon="check-circle-fill" class="mr-2" />
                L'utilisateur dispose d'une adhesion valide.
              </div>
            </b-card>

            <template  v-else>
            <b-card class="bg-danger text-white border-0 mb-3">
              <div class="font-weight-bold d-flex align-items-center">
                <b-icon icon="exclamation-triangle-fill" class="mr-2" />
                L'utilisateur n'a pas d'adhesion valide.
              </div>
            </b-card>
            <p class="text-muted">
              L'adhesion doit etre achetée et reliée au compte utilisateur avant de pouvoir participer a l'ouverture.
              Tu peux ajouter une adhesion pour cet utilisateur directement depuis ce formulaire, ou lui demander de le faire lui-meme depuis son espace personnel.
            </p>
            <b-card class="border mb-3">
              <h6 class="mb-3">Ajouter une adhesion</h6>
              <b-form-group label="Type d'adhesion" label-for="add-user-adhesion-type">
                <b-form-select
                  id="add-user-adhesion-type"
                  v-model="addUserForm.adhesion.type"
                  :options="adhesionTypes"
                ></b-form-select>
              </b-form-group>

            <b-form-group label="Paiement" label-for="add-user-adhesion-payment">
              <b-form-select
                id="add-user-adhesion-payment"
                v-model="addUserForm.adhesion.payment"
                :options="paymentTypes"
              ></b-form-select>
            </b-form-group>

              <b-form-group v-if="addUserForm.adhesion.type === 'SAISON_SIMPLE'" label="Tarif reduit">
                <b-form-checkbox v-model="addUserForm.adhesion.reduite">
                  Je beneficie d'un tarif reduit
                </b-form-checkbox>
                <small class="text-muted">
                  Mineur, handicap, etudiant ou chomage.
                </small>
              </b-form-group>

              <b-form-group
                v-if="addUserForm.adhesion.type === 'SAISON_SIMPLE' && addUserForm.adhesion.reduite"
                label="Motif du tarif reduit"
                label-for="add-user-adhesion-reduite-reason"
              >
                <b-form-select
                  id="add-user-adhesion-reduite-reason"
                  v-model="addUserForm.adhesion.reduiteReason"
                  :options="reduiteReasons"
                ></b-form-select>
              </b-form-group>

              <div class="text-right">
                <b-button
                  type="button"
                  variant="outline-primary"
                  size="sm"
                  :disabled="addUserCreateAdhesionLoading"
                  @click="createAdhesionForSelectedUser"
                >
                  <b-spinner v-if="addUserCreateAdhesionLoading" small class="mr-2"></b-spinner>
                  Créer l'adhesion
                </b-button>
              </div>

          </b-card>
            </template>
            </div>
          </template>


          <div class="form-section">
            <div class="form-section-heading">
              <b-icon icon="truck" class="form-section-heading__icon" scale="0.6" />
              <span>Covoit <span class="required-asterisk">*</span></span>
            </div>
            <b-form-group class="mb-0">
            <b-alert
              v-if="addUserForm.carpoolDetected"
              show
              variant="info"
              class="d-flex align-items-center justify-content-between py-2 px-3 mb-2"
            >
              <span v-if="addUserForm.carpoolDetected.role === 'driver'">
                <b-icon icon="truck" class="mr-1" />
                Conducteur — {{ addUserForm.carpoolDetected.covoit.passenger.length + 1 }} personne(s) dans le covoit
              </span>
              <span v-else>
                <b-icon icon="people-fill" class="mr-1" />
                Passager — covoit de {{ addUserForm.carpoolDetected.covoit.driver.name }} {{ addUserForm.carpoolDetected.covoit.driver.surname }}
              </span>
              <b-button size="sm" style="color: white; border: white;" @click="addUserForm.carpoolDetected = null; addUserForm.carpoolCount = ''">
                Ignorer
              </b-button>
            </b-alert>
            <b-form-input
              v-model="addUserForm.carpoolCount"
              type="number"
              min="0"
              placeholder="Nombre de personne dans la voiture"
              :state="isCarpoolFilled ? null : false"
            />
            <small v-if="!isCarpoolFilled" class="text-danger d-block mt-1">
              Veuillez renseigner le nombre de personne présente dans la voiture pour pouvoir ajouter l'utilisateur.
            </small>
            </b-form-group>
          </div>


          <div class="form-section">
            <div class="form-section-heading">
              <b-icon icon="gear" class="form-section-heading__icon" scale="0.6" />
              <span>Matos</span>
            </div>
          <b-row>
            <b-col cols="12" md="6">
              <b-card class="border mb-3" header="Voile" header-class="font-weight-bold">
                <GearSearchSelect
                  v-if="!addUserForm.sail"
                  v-model="addUserForm.sail"
                  type="sails"
                  placeholder="Nom, taille ou reference"
                  no-results-text="Aucune voile ne correspond a cette recherche."
                />
                <div v-else class="d-flex justify-content-between align-items-center">
                  <div class="flex-grow-1 mr-2">
                    <div class="font-weight-bold">{{ gearPrimaryLabel(addUserForm.sail, 'sail') }}</div>
                    <small v-if="gearSecondaryLabel(addUserForm.sail, 'sail')" class="text-muted">
                      {{ gearSecondaryLabel(addUserForm.sail, 'sail') }}
                    </small>
                  </div>
                  <b-badge
                    :variant="addUserForm.sail.rigged ? 'success' : 'secondary'"
                    pill
                    class="mr-2"
                  >
                    {{ addUserForm.sail.rigged ? 'Gréée' : 'Non gréée' }}
                  </b-badge>
                  <b-button size="sm" variant="outline-danger" @click="addUserForm.sail = null">
                    Retirer
                  </b-button>
                </div>
              </b-card>
            </b-col>
            <b-col cols="12" md="6">
              <b-card class="border mb-3" header="Planche" header-class="font-weight-bold">
                <GearSearchSelect
                  v-if="!addUserForm.board"
                  v-model="addUserForm.board"
                  type="boards"
                  placeholder="Nom, volume ou reference"
                  no-results-text="Aucune planche ne correspond a cette recherche."
                />
                <div v-else class="d-flex justify-content-between align-items-center">
                  <div class="flex-grow-1 mr-2">
                    <div class="font-weight-bold">{{ gearPrimaryLabel(addUserForm.board, 'board') }}</div>
                    <small v-if="gearSecondaryLabel(addUserForm.board, 'board')" class="text-muted">
                      {{ gearSecondaryLabel(addUserForm.board, 'board') }}
                    </small>
                  </div>
                  <b-button size="sm" variant="outline-danger" @click="addUserForm.board = null">
                    Retirer
                  </b-button>
                </div>
              </b-card>
            </b-col>
          </b-row>

          <b-form-group label="Équipement" class="mb-0 mt-3">
            <div class="equipment-options">
              <label
                class="equipment-option"
                :class="{ 'equipment-option--active': addUserForm.harness }"
              >
                <input v-model="addUserForm.harness" type="checkbox" class="equipment-option__input" />
                <svg
                  class="equipment-option__icon"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  stroke-width="1.7"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  aria-hidden="true"
                >
                  <rect x="3" y="8" width="18" height="6" rx="2" />
                  <line x1="8" y1="8.5" x2="8" y2="13.5" />
                  <line x1="16" y1="8.5" x2="16" y2="13.5" />
                  <path d="M12 14v2.3a2.2 2.2 0 1 0 2.2-2.2" />
                </svg>
                <span class="equipment-option__label">Harnais</span>
                <b-icon
                  :icon="addUserForm.harness ? 'check-circle-fill' : 'circle'"
                  class="equipment-option__state"
                />
              </label>
              <label
                class="equipment-option"
                :class="{ 'equipment-option--active': addUserForm.wetsuit }"
              >
                <input v-model="addUserForm.wetsuit" type="checkbox" class="equipment-option__input" />
                <svg
                  class="equipment-option__icon"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  stroke-width="1.6"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  aria-hidden="true"
                >
                  <path d="M10 3 7 4 4 6 6 8.5 7 9v12h4v-6h2v6h4V9l1-0.5 2-2.5-3-2-3-1z" />
                  <path d="M10 3c.6 1.2 3.4 1.2 4 0" />
                </svg>
                <span class="equipment-option__label">Combi</span>
                <b-icon
                  :icon="addUserForm.wetsuit ? 'check-circle-fill' : 'circle'"
                  class="equipment-option__state"
                />
              </label>
            </div>
          </b-form-group>
          </div>


          <div class="form-section">
            <div class="form-section-heading">
              <b-icon icon="chat-left-text-fill" class="form-section-heading__icon" scale="0.6" />
              <span>Commentaire</span>
            </div>
            <b-form-group class="mb-0">
              <b-form-textarea
                v-model="addUserForm.comment"
                rows="3"
                placeholder="Informations complémentaires (optionnel)"
              />
            </b-form-group>
          </div>

          <div class="add-user-actions">
            <b-button
              type="submit"
              variant="primary"
              size="lg"
              :disabled="!canAddUser || !isCarpoolFilled || addUserLoading"
            >
              <b-spinner v-if="addUserLoading" small class="mr-2"></b-spinner>
              <b-icon v-else icon="person-plus-fill" class="mr-2" />
              Ajouter l'utilisateur
            </b-button>
          </div>
        </b-form>
      </b-collapse>
    </b-card>

    <div class="refresh-indicator d-flex align-items-center text-muted small">
      <b-spinner v-if="isRefreshing" small variant="secondary" class="mr-1" />
      <b-icon v-else icon="arrow-clockwise" class="mr-1" />
      <span v-if="isRefreshing">Actualisation...</span>
      <span v-else-if="secondsUntilRefresh > 0">
        Prochaine actualisation dans {{ secondsUntilRefresh }}s
      </span>
      <span v-else>En attente...</span>
      <b-button
        size="sm"
        variant="link"
        class="py-0 px-1 ml-1 refresh-button"
        :disabled="isRefreshing"
        @click="manualRefresh"
      >
        Actualiser
      </b-button>
    </div>

    <b-card class="mb-4">
      <div
        v-b-toggle.opening-preregistrants
        class="d-flex align-items-center justify-content-between collapse-toggle"
      >
        <h4 class="mb-0">
          Liste des préinscrits
          <b-badge v-if="preregistrants.length" variant="warning" class="ml-2">{{ preregistrants.length }}</b-badge>
        </h4>
        <b-icon icon="chevron-down" class="collapse-chevron"></b-icon>
      </div>
      <b-collapse id="opening-preregistrants" visible>
        <p class="text-muted small mt-2 mb-3">
          Ces personnes se sont préinscrites via le portail. Valide une préinscription pour l'ajouter à la liste des participants.
        </p>
        <div v-if="!preregistrants.length" class="text-muted py-2">
          Aucune préinscription en attente.
        </div>
        <template v-else>
          <b-table-simple responsive class="mb-0 d-none d-md-table participants-table">
            <b-thead>
              <b-tr>
                <b-th>Nom</b-th>
                <b-th>Voile</b-th>
                <b-th>Flotteur</b-th>
                <b-th>Harnais</b-th>
                <b-th>Combi</b-th>
                <b-th class="text-center">Covoit</b-th>
                <b-th class="text-right">Actions</b-th>
              </b-tr>
            </b-thead>
            <b-tbody>
              <b-tr
                v-for="prereg in preregistrants"
                :key="prereg._id"
                class="participant-row preregistrant-row"
                @click="openEditRegistrantModal(prereg)"
              >
                <b-td>{{ prereg.user.name }} {{ prereg.user.surname }}</b-td>
                <b-td>
                  <div class="d-flex align-items-center">
                    <div>
                      <div>{{ gearPrimaryLabel(prereg.sail, 'sail') }}</div>
                      <small v-if="gearSecondaryLabel(prereg.sail, 'sail')" class="text-muted">
                        {{ gearSecondaryLabel(prereg.sail, 'sail') }}
                      </small>
                    </div>
                    <b-button
                      v-if="prereg.sail"
                      size="sm"
                      variant="link"
                      class="p-0 ml-2 text-secondary"
                      aria-label="Details voile"
                      @click.stop="openGearInfoModal(prereg.sail, 'Voile')"
                    >
                      <b-icon icon="info-circle" />
                    </b-button>
                  </div>
                </b-td>
                <b-td>
                  <div class="d-flex align-items-center">
                    <div>
                      <div>{{ gearPrimaryLabel(prereg.board, 'board') }}</div>
                      <small v-if="gearSecondaryLabel(prereg.board, 'board')" class="text-muted">
                        {{ gearSecondaryLabel(prereg.board, 'board') }}
                      </small>
                    </div>
                    <b-button
                      v-if="prereg.board"
                      size="sm"
                      variant="link"
                      class="p-0 ml-2 text-secondary"
                      aria-label="Details flotteur"
                      @click.stop="openGearInfoModal(prereg.board, 'Flotteur')"
                    >
                      <b-icon icon="info-circle" />
                    </b-button>
                  </div>
                </b-td>
                <b-td class="text-center">
                  <b-icon v-if="prereg.harnais === false" icon="x-lg" variant="danger"></b-icon>
                  <b-icon v-else                          icon="check-lg" variant="success"></b-icon>
                </b-td>
                <b-td class="text-center">
                  <b-icon v-if="prereg.combi === false" icon="x-lg" variant="danger"></b-icon>
                  <b-icon v-else                        icon="check-lg" variant="success"></b-icon>
                </b-td>
                <b-td class="text-center">{{ covoitCountFor(prereg) }}</b-td>
                <b-td class="text-right" @click.stop>
                  <b-button-group size="sm" class="actions-group">
                    <b-button
                      variant="outline-success"
                      aria-label="Valider la préinscription"
                      title="Valider la préinscription"
                      :disabled="validatePreregLoadingId === prereg._id"
                      @click="validatePreregistration(prereg)"
                    >
                      <b-spinner v-if="validatePreregLoadingId === prereg._id" small />
                      <b-icon v-else icon="check2-circle" />
                    </b-button>
                    <b-button
                      variant="outline-primary"
                      aria-label="Modifier"
                      title="Modifier"
                      @click="openEditRegistrantModal(prereg)"
                    >
                      <b-icon icon="pencil-square" />
                    </b-button>
                    <b-button
                      variant="outline-danger"
                      aria-label="Supprimer"
                      title="Supprimer"
                      :disabled="removePreregLoadingId === prereg._id"
                      @click="removePreregistration(prereg)"
                    >
                      <b-spinner v-if="removePreregLoadingId === prereg._id" small />
                      <b-icon v-else icon="trash" />
                    </b-button>
                  </b-button-group>
                </b-td>
              </b-tr>
            </b-tbody>
          </b-table-simple>

          <div class="d-md-none">
            <b-card
              v-for="prereg in preregistrants"
              :key="`prereg-card-${prereg._id}`"
              class="registrant-card registrant-card--info mb-3"
              @click.native="openEditRegistrantModal(prereg)"
            >
              <div class="d-flex justify-content-between align-items-start mb-2">
                <div class="font-weight-bold">
                  {{ prereg.user.name }} {{ prereg.user.surname }}
                </div>
                <div class="registrant-actions-icons" @click.stop>
                  <b-button
                    size="sm"
                    variant="link"
                    class="p-0 text-success"
                    :disabled="validatePreregLoadingId === prereg._id"
                    aria-label="Valider"
                    @click="validatePreregistration(prereg)"
                  >
                    <b-spinner v-if="validatePreregLoadingId === prereg._id" small />
                    <b-icon v-else icon="check2-circle" font-scale="1.3" />
                  </b-button>
                  <b-button
                    size="sm"
                    variant="link"
                    class="p-0 text-primary ml-2"
                    aria-label="Modifier"
                    @click="openEditRegistrantModal(prereg)"
                  >
                    <b-icon icon="pencil-square" font-scale="1.2" />
                  </b-button>
                  <b-button
                    size="sm"
                    variant="link"
                    class="p-0 text-danger ml-2"
                    :disabled="removePreregLoadingId === prereg._id"
                    aria-label="Supprimer"
                    @click="removePreregistration(prereg)"
                  >
                    <b-spinner v-if="removePreregLoadingId === prereg._id" small />
                    <b-icon v-else icon="trash" font-scale="1.2" />
                  </b-button>
                </div>
              </div>
              <hr>
              <div class="registrant-meta">
                <div class="registrant-meta__row">
                  <span class="registrant-meta__label">Voile</span>
                  <span class="registrant-meta__value">{{ gearPrimaryLabel(prereg.sail, 'sail') }}</span>
                </div>
                <hr>
                <div class="registrant-meta__row">
                  <span class="registrant-meta__label">Flotteur</span>
                  <span class="registrant-meta__value">{{ gearPrimaryLabel(prereg.board, 'board') }}</span>
                </div>
                <hr>
                <div class="registrant-meta__row">
                  <span class="registrant-meta__label">Harnais</span>
                  <span class="registrant-meta__value">
                    <b-icon v-if="prereg.harnais === false" icon="x-lg" variant="danger"></b-icon>
                    <b-icon v-else icon="check-lg" variant="success"></b-icon>
                  </span>
                </div>
                <hr>
                <div class="registrant-meta__row">
                  <span class="registrant-meta__label">Combi</span>
                  <span class="registrant-meta__value">
                    <b-icon v-if="prereg.combi === false" icon="x-lg" variant="danger"></b-icon>
                    <b-icon v-else icon="check-lg" variant="success"></b-icon>
                  </span>
                </div>
                <hr>
                <div class="registrant-meta__row">
                  <span class="registrant-meta__label">Covoit</span>
                  <span class="registrant-meta__value">{{ covoitCountFor(prereg) }}</span>
                </div>
              </div>
            </b-card>
          </div>
        </template>
      </b-collapse>
    </b-card>

    <b-card class="mb-4">
      <div
        v-b-toggle.opening-registrants
        class="d-flex align-items-center justify-content-between collapse-toggle"
      >
        <h4 class="mb-0">Liste des inscrits</h4>
        <b-icon icon="chevron-down" class="collapse-chevron"></b-icon>
      </div>
      <b-collapse id="opening-registrants" visible>
        <b-table-simple responsive class="mb-0 d-none d-md-table participants-table" >
          <b-thead>
            <b-tr>
              <b-th>Nom</b-th>
              <b-th>Voile</b-th>
              <b-th>Flotteur</b-th>
              <b-th class="text-center">Harnais</b-th>
              <b-th class="text-center">Combi</b-th>
              <b-th class="text-center">Verif Matos</b-th>
              <b-th class="text-center">Matos rendu</b-th>
              <b-th class="text-right">Actions</b-th>
            </b-tr>
          </b-thead>
          <b-tbody>
            <b-tr
              v-for="registrant in registrants"
              :key="registrant.id || registrant._id"
              :variant="registrant.returned ? 'success' : registrant.checkedOut ? null : 'warning'"
              class="participant-row"
              @click="openEditRegistrantModal(registrant)"
            >
              <b-td>{{ registrant.user.name }} {{ registrant.user.surname }}</b-td>
              <b-td>
                <div class="d-flex align-items-center">
                  <div>
                    <div>{{ gearPrimaryLabel(registrant.sail, 'sail') }}</div>
                    <small v-if="gearSecondaryLabel(registrant.sail, 'sail')" class="text-muted">
                      {{ gearSecondaryLabel(registrant.sail, 'sail') }}
                    </small>
                  </div>
                  <b-button
                    v-if="registrant.sail"
                    size="sm"
                    variant="link"
                    class="p-0 ml-2 text-secondary"
                    aria-label="Details voile"
                    @click.stop="openGearInfoModal(registrant.sail, 'Voile')"
                  >
                    <b-icon icon="info-circle" />
                  </b-button>
                </div>
              </b-td>
              <b-td>
                <div class="d-flex align-items-center">
                  <div>
                    <div>{{ gearPrimaryLabel(registrant.board, 'board') }}</div>
                    <small v-if="gearSecondaryLabel(registrant.board, 'board')" class="text-muted">
                      {{ gearSecondaryLabel(registrant.board, 'board') }}
                    </small>
                  </div>
                  <b-button
                    v-if="registrant.board"
                    size="sm"
                    variant="link"
                    class="p-0 ml-2 text-secondary"
                    aria-label="Details flotteur"
                    @click.stop="openGearInfoModal(registrant.board, 'Flotteur')"
                  >
                    <b-icon icon="info-circle" />
                  </b-button>
                </div>
              </b-td>

              <b-td class="text-center">
                <b-icon v-if="registrant.harnais === false" icon="x-lg" variant="danger"></b-icon>
                <b-icon v-else                              icon="check-lg" variant="success"></b-icon>
              </b-td>

              <b-td class="text-center">
                <b-icon v-if="registrant.combi === false" icon="x-lg" variant="danger"></b-icon>
                <b-icon v-else                            icon="check-lg" variant="success"></b-icon>
              </b-td>

              <b-td class="text-center" @click.stop>
                <b-form-checkbox v-model="registrant.checkedOut" switch :disabled="registrant.returned" @change="updateCheckStatus(registrant, 'checkedOut', $event)"/>
              </b-td>
              <b-td class="text-center" @click.stop>
                <b-form-checkbox v-model="registrant.returned" switch :disabled="!registrant.checkedOut || registrant.returned" @change="handleReturnedChange(registrant, $event)"/>
              </b-td>
              <b-td class="text-right" @click.stop>
                <b-button-group size="sm" class="actions-group">
                  <b-button
                    variant="outline-primary"
                    aria-label="Modifier"
                    title="Modifier"
                    @click="openEditRegistrantModal(registrant)"
                  >
                    <b-icon icon="pencil-square" />
                  </b-button>
                  <b-button
                    variant="outline-danger"
                    aria-label="Supprimer"
                    title="Supprimer"
                    :disabled="removeParticipantLoadingId === (registrant.id || registrant._id)"
                    @click="removeParticipant(registrant)"
                  >
                    <b-spinner v-if="removeParticipantLoadingId === (registrant.id || registrant._id)" small />
                    <b-icon v-else icon="trash" />
                  </b-button>
                  <b-button
                    variant="outline-warning"
                    aria-label="Signaler"
                    title="Signaler"
                    @click="openReportModal(registrant)"
                  >
                    <b-icon icon="exclamation-triangle" />
                  </b-button>
                </b-button-group>
              </b-td>
            </b-tr>
          </b-tbody>
        </b-table-simple>

        <div class="d-md-none">
          <b-card
            v-for="registrant in registrants"
            :key="`card-${registrant.id || registrant._id}`"
            class="registrant-card mb-3"
            :class="{
              'registrant-card--success': registrant.returned,
              'registrant-card--warning': !registrant.returned && !registrant.checkedOut
            }"
            @click.native="openEditRegistrantModal(registrant)"
          >
            <div class="d-flex justify-content-between align-items-start mb-2">
              <div class="font-weight-bold">
                {{ registrant.user.name }} {{ registrant.user.surname }}
              </div>
              <div class="registrant-actions-icons" @click.stop>
                <b-button
                  size="sm"
                  variant="link"
                  class="p-0 text-primary"
                  @click="openEditRegistrantModal(registrant)"
                  aria-label="Modifier"
                >
                  <b-icon icon="pencil-square" font-scale="1.2" />
                </b-button>
                <b-button
                  size="sm"
                  variant="link"
                  class="p-0 text-danger ml-2"
                  :disabled="removeParticipantLoadingId === (registrant.id || registrant._id)"
                  @click="removeParticipant(registrant)"
                  aria-label="Supprimer"
                >
                  <b-spinner
                    v-if="removeParticipantLoadingId === (registrant.id || registrant._id)"
                    small
                  />
                  <b-icon v-else icon="trash" font-scale="1.2" />
                </b-button>
                <b-button
                  size="sm"
                  variant="link"
                  class="p-0 text-warning ml-2"
                  @click="openReportModal(registrant)"
                  aria-label="Signaler"
                >
                  <b-icon icon="exclamation-triangle" font-scale="1.2" />
                </b-button>
              </div>
            </div>
            <hr>
            <div class="registrant-meta">
              <div class="registrant-meta__row">
                <span class="registrant-meta__label">Voile</span>
                <span class="registrant-meta__value d-flex align-items-center">
                  <span class="d-flex flex-column">
                    <span>{{ gearPrimaryLabel(registrant.sail, 'sail') }}</span>
                    <small v-if="gearSecondaryLabel(registrant.sail, 'sail')" class="text-muted">
                      {{ gearSecondaryLabel(registrant.sail, 'sail') }}
                    </small>
                  </span>
                  <b-badge
                    v-if="registrant.sail"
                    :variant="registrant.sail.rigged ? 'success' : 'secondary'"
                    pill
                    class="ml-2"
                  >
                    {{ registrant.sail.rigged ? 'Gréée' : 'Non gréée' }}
                  </b-badge>
                  <b-button
                    v-if="registrant.sail"
                    size="sm"
                    variant="link"
                    class="p-0 ml-2 text-secondary"
                    aria-label="Details voile"
                    @click.stop="openGearInfoModal(registrant.sail, 'Voile')"
                  >
                    <b-icon icon="info-circle" />
                  </b-button>
                </span>
              </div>
              <hr>
              <div class="registrant-meta__row">
                <span class="registrant-meta__label">Flotteur</span>
                <span class="registrant-meta__value d-flex align-items-center">
                  <span class="d-flex flex-column">
                    <span>{{ gearPrimaryLabel(registrant.board, 'board') }}</span>
                    <small v-if="gearSecondaryLabel(registrant.board, 'board')" class="text-muted">
                      {{ gearSecondaryLabel(registrant.board, 'board') }}
                    </small>
                  </span>
                  <b-button
                    v-if="registrant.board"
                    size="sm"
                    variant="link"
                    class="p-0 ml-2 text-secondary"
                    aria-label="Details flotteur"
                    @click.stop="openGearInfoModal(registrant.board, 'Flotteur')"
                  >
                    <b-icon icon="info-circle" />
                  </b-button>
                </span>
              </div>
            </div>
            <hr>
            <div class="registrant-meta">
              <div class="registrant-meta__row">
                <span class="registrant-meta__label">Combi</span>
                <span class="registrant-meta__value">
                  <b-icon v-if="registrant.combi === false" icon="x-lg" variant="danger"></b-icon>
                  <b-icon v-else icon="check-lg" variant="success"></b-icon>  
                </span>
              </div>
              <hr>
              <div class="registrant-meta__row">
                <span class="registrant-meta__label">Harnais</span>
                <span class="registrant-meta__value">
                  <b-icon v-if="registrant.harnais === false" icon="x-lg" variant="danger"></b-icon>
                  <b-icon v-else icon="check-lg" variant="success"></b-icon>  
                </span>
              </div>
            </div>
            <hr>
            <div class="registrant-switches" @click.stop>
              <div class="registrant-switches__row">
                <span class="registrant-switches__label">Verif Matos</span>
                <b-form-checkbox v-model="registrant.checkedOut" switch :disabled="registrant.returned" @change="updateCheckStatus(registrant, 'checkedOut', $event)"/>
              </div>
              <hr>
              <div class="registrant-switches__row">
                <span class="registrant-switches__label">Matos rendu</span>
                <b-form-checkbox v-model="registrant.returned" switch :disabled="!registrant.checkedOut || registrant.returned" @change="handleReturnedChange(registrant, $event)"/>
              </div>
            </div>
          </b-card>
        </div>
      </b-collapse>
    </b-card>

    <b-modal
      :visible="gearInfoModalVisible"
      :title="`Details ${gearInfoType || 'matos'}`"
      @update:visible="gearInfoModalVisible = $event"
      @hidden="closeGearInfoModal"
      ok-only
      ok-title="Fermer"
      centered
      size="lg"
    >
      <div v-if="gearInfoItem">
        <div
          v-for="entry in gearInfoFields(gearInfoItem)"
          :key="entry.key"
          class="gear-info-row"
        >
          <b-icon :icon="entry.icon" class="gear-info-row__icon" />
          <div class="gear-info-row__content">
            <div class="gear-info-row__label">{{ entry.label }}</div>
            <div class="gear-info-row__value">{{ entry.value }}</div>
          </div>
        </div>
      </div>
      <div v-else class="text-muted">Aucune information disponible.</div>
    </b-modal>

    <b-modal
      :visible="editRegistrantModalVisible"
      title="Modifier l'inscription"
      @update:visible="editRegistrantModalVisible = $event"
      @ok="applyRegistrantEdition"
      @hidden="closeEditRegistrantModal"
      ok-title="Enregistrer"
      cancel-title="Annuler"
      size="lg"
      centered
    >
      <b-form @submit.prevent="applyRegistrantEdition">
        <b-form-group label="Voiles utilisées" label-class="gear-used-label">
          <ul
            v-if="editSailsUsedItems.length"
            class="gear-used-list list-unstyled mb-2"
          >
            <li
              v-for="(item, index) in editSailsUsedItems"
              :key="`edit-sail-${item.id || index}`"
              class="gear-used-row"
            >
              <div class="gear-used-row__main">
                <div class="gear-used-row__primary">{{ item.primary }}</div>
                <div v-if="item.secondary" class="gear-used-row__secondary">
                  {{ item.secondary }}
                </div>
              </div>
              <b-badge
                v-if="item.rigged !== null"
                :variant="item.rigged ? 'success' : 'secondary'"
                pill
                class="gear-used-row__badge"
              >
                {{ item.rigged ? 'Gréée' : 'Non gréée' }}
              </b-badge>
              <b-button
                size="sm"
                variant="outline-danger"
                class="gear-used-row__action"
                :disabled="removeUsedGearLoadingKey === `sail-${item.id}`"
                @click="removeSailUsed(editRegistrantTarget, item.id)"
              >
                <b-spinner v-if="removeUsedGearLoadingKey === `sail-${item.id}`" small />
                <b-icon v-else icon="trash"></b-icon>
              </b-button>
            </li>
          </ul>
          <div v-else class="gear-used-empty mb-2">
            <b-icon icon="dash-circle" class="mr-2" />
            Aucune voile pour le moment.
          </div>
          <div v-if="addSailMode" class="gear-add-zone">
            <GearSearchSelect
              :value="null"
              type="sails"
              placeholder="Nom, taille ou reference"
              no-results-text="Aucune voile ne correspond a cette recherche."
              :disabled="addUsedGearLoading"
              @selected="onAddSailSelected"
            />
            <div class="text-right">
              <b-button
                size="sm"
                variant="link"
                class="text-muted px-0"
                :disabled="addUsedGearLoading"
                @click="addSailMode = false"
              >
                Annuler
              </b-button>
            </div>
          </div>
          <b-button
            v-else
            variant="outline-primary"
            block
            class="gear-add-button"
            :disabled="addUsedGearLoading"
            @click="addSailMode = true"
          >
            <b-spinner v-if="addUsedGearLoading" small class="mr-2" />
            <b-icon v-else icon="plus-circle" class="mr-2" />
            Ajouter une voile
          </b-button>
        </b-form-group>

        <b-form-group label="Planches utilisées" label-class="gear-used-label">
          <ul
            v-if="editBoardsUsedItems.length"
            class="gear-used-list list-unstyled mb-2"
          >
            <li
              v-for="(item, index) in editBoardsUsedItems"
              :key="`edit-board-${item.id || index}`"
              class="gear-used-row"
            >
              <div class="gear-used-row__main">
                <div class="gear-used-row__primary">{{ item.primary }}</div>
                <div v-if="item.secondary" class="gear-used-row__secondary">
                  {{ item.secondary }}
                </div>
              </div>
              <b-button
                size="sm"
                variant="outline-danger"
                class="gear-used-row__action"
                :disabled="removeUsedGearLoadingKey === `board-${item.id}`"
                @click="removeBoardUsed(editRegistrantTarget, item.id)"
              >
                <b-spinner v-if="removeUsedGearLoadingKey === `board-${item.id}`" small />
                <b-icon v-else icon="trash"></b-icon>
              </b-button>
            </li>
          </ul>
          <div v-else class="gear-used-empty mb-2">
            <b-icon icon="dash-circle" class="mr-2" />
            Aucune planche pour le moment.
          </div>
          <div v-if="addBoardMode" class="gear-add-zone">
            <GearSearchSelect
              :value="null"
              type="boards"
              placeholder="Nom, volume ou reference"
              no-results-text="Aucune planche ne correspond a cette recherche."
              :disabled="addUsedGearLoading"
              @selected="onAddBoardSelected"
            />
            <div class="text-right">
              <b-button
                size="sm"
                variant="link"
                class="text-muted px-0"
                :disabled="addUsedGearLoading"
                @click="addBoardMode = false"
              >
                Annuler
              </b-button>
            </div>
          </div>
          <b-button
            v-else
            variant="outline-primary"
            block
            class="gear-add-button"
            :disabled="addUsedGearLoading"
            @click="addBoardMode = true"
          >
            <b-spinner v-if="addUsedGearLoading" small class="mr-2" />
            <b-icon v-else icon="plus-circle" class="mr-2" />
            Ajouter une planche
          </b-button>
        </b-form-group>

        <b-form-group label="Covoiturage" label-class="gear-used-label">
          <div class="carpool-edit">
            <b-icon icon="people-fill" class="carpool-edit__icon" font-scale="1.4" />
            <span class="carpool-edit__label">Personne(s) dans le covoit</span>
            <b-form-spinbutton
              v-model="editRegistrantForm.covoit"
              :min="0"
              :max="10"
              inline
              size="sm"
              class="carpool-edit__input"
              aria-label="Nombre de personnes dans le covoit"
            />
          </div>
        </b-form-group>

        <hr>

        <b-form-group>
          <b-form-checkbox v-model="editRegistrantForm.harnais" switch>
            Harnais
          </b-form-checkbox>
        </b-form-group>
        <b-form-group>
          <b-form-checkbox v-model="editRegistrantForm.combi" switch>
            Combi
          </b-form-checkbox>
        </b-form-group>
        <b-form-group label="Commentaire">
          <b-form-textarea
            v-model="editRegistrantForm.commentaire"
            rows="3"
            placeholder="Ajouter un commentaire"
          />
        </b-form-group>
      </b-form>
    </b-modal>

    <b-modal
      :visible="reportModalVisible"
      title="Signaler un probleme"
      @update:visible="reportModalVisible = $event"
      @hidden="reportModalVisible = false"
      @ok="sendSignalement"
      ok-title="Envoyer"
      cancel-title="Annuler"
      centered
    >
      <b-form @submit.prevent="closeReportModal">
        <b-form-group label="Element lié au participant">
          <b-form-select
            v-model="signalementForm.linkedObjectSelection"
            :options="signalementTargetOptions"
          />
        </b-form-group>
        <b-form-group label="Commentaire">
          <b-form-textarea
            v-model="signalementForm.commentaire"
            rows="3"
            placeholder="Decrivez le probleme..."
          />
        </b-form-group>
        <b-form-group
          v-if="
            signalementForm.linkedObjectSelection &&
            signalementTargetMap[signalementForm.linkedObjectSelection] &&
            signalementTargetMap[signalementForm.linkedObjectSelection].linkedObjectType !== 'User'
          "
        >
          <b-form-checkbox v-model="signalementForm.disable">
            Mettre inutilisable
          </b-form-checkbox>
        </b-form-group>

        <p>
          Si vous avez des photos ou des vidéos, envoyez les par mail à l'adresse <a href="mailto:gucvoile@gmail.com">gucvoile@gmail.com</a> ou par messenger au compte du GUC Voile.
        </p>
        <p>
          Réfère toi au guide de l'ouvreur pour la suite avec le matériel endommagé !
        </p>
      </b-form>
    </b-modal>

    <b-modal
      :visible="returnGearModalVisible"
      title="Retour du matériel"
      @update:visible="returnGearModalVisible = $event"
      @hidden="onReturnGearModalHidden"
      centered
      no-close-on-backdrop
      hide-header-close
    >
      <div v-if="returnGearTarget">
        <p class="mb-3">
          Matériel utilisé par
          <strong>{{ returnGearTarget.user.name }} {{ returnGearTarget.user.surname }}</strong>.
          Retirez les éléments qui n'ont <strong>PAS</strong> été utilisés, garder uniquement les éléments qui ont vraiment été sur l'eau.
        </p>

        <b-form-group label="Voiles utilisées">
          <ul
            v-if="getSailsUsedItems(returnGearTarget.sailsUsed).length"
            class="mb-0 pl-3"
          >
            <li
              v-for="(item, index) in getSailsUsedItems(returnGearTarget.sailsUsed)"
              :key="`return-sail-${index}`"
              class="d-flex align-items-center justify-content-between mb-1"
            >
              <span>{{ item.label }}</span>
              <b-button
                size="sm"
                variant="outline-danger"
                :disabled="removeUsedGearLoadingKey === `sail-${item.id}`"
                @click="removeSailUsed(returnGearTarget, item.id)"
              >
                <b-spinner v-if="removeUsedGearLoadingKey === `sail-${item.id}`" small />
                <b-icon v-else icon="trash"></b-icon>
              </b-button>
            </li>
          </ul>
          <div v-else class="text-muted small">Aucune voile utilisée.</div>
        </b-form-group>

        <b-form-group label="Planches utilisées" class="mb-0">
          <ul
            v-if="getBoardsUsedItems(returnGearTarget.boardsUsed).length"
            class="mb-0 pl-3"
          >
            <li
              v-for="(item, index) in getBoardsUsedItems(returnGearTarget.boardsUsed)"
              :key="`return-board-${index}`"
              class="d-flex align-items-center justify-content-between mb-1"
            >
              <span>{{ item.label }}</span>
              <b-button
                size="sm"
                variant="outline-danger"
                :disabled="removeUsedGearLoadingKey === `board-${item.id}`"
                @click="removeBoardUsed(returnGearTarget, item.id)"
              >
                <b-spinner v-if="removeUsedGearLoadingKey === `board-${item.id}`" small />
                <b-icon v-else icon="trash"></b-icon>
              </b-button>
            </li>
          </ul>
          <div v-else class="text-muted small">Aucune planche utilisée.</div>
        </b-form-group>
      </div>

      <template #modal-footer>
        <b-button variant="secondary" :disabled="returnGearConfirming" @click="cancelReturnGear">
          Annuler
        </b-button>
        <b-button variant="primary" :disabled="returnGearConfirming" @click="confirmReturnGear">
          <b-spinner v-if="returnGearConfirming" small class="mr-1" />
          Confirmer le retour
        </b-button>
      </template>
    </b-modal>
  </div>
</template>

<script>
import axios from 'axios';
import session from "@/store/session";
import UserSearchSelect from "@/components/UserSearchSelect.vue";
import GearSearchSelect from "@/components/GearSearchSelect.vue";
import HourMinutePicker from "@/components/HourMinutePicker.vue";
import OpeningService from "../services/opening.service";
import SignalementService from "@/services/signalement.service";
import AdhesionService from "../services/adhesion.service";
import UserService from "@/services/user.service";

const buildCreateUserForm = () => ({
  name: "",
  surname: "",
  bornAt: "",
  gender: "",
  phoneNumber: "",
  email: "",
  newsletter: false,
  photoConsent: false,
  swimmingConsent: false,
  reglementConsent: false
});

const buildAddUserForm = () => ({
  selectedUser: null,
  paperForm: false,
  sendReset: false,
  hasValidAdhesion: false,
  create: buildCreateUserForm(),
  adhesion: {
    type: "SAISON_SIMPLE",
    payment: "LIQUIDE",
    reduite: false,
    reduiteReason: ""
  },
  carpoolCount: "",
  carpoolDetected: null,
  comment: "",
  sail: null,
  board: null,
  harness: false,
  wetsuit: false
});

export default {
  name: "ManageOpening",
  components: {
    UserSearchSelect,
    GearSearchSelect,
    HourMinutePicker
  },
  data() {
    return {
      refreshIntervalMs: 20000,
      refreshIntervalId: null,
      countdownIntervalId: null,
      visibilityHandler: null,
      secondsUntilRefresh: 20,
      isRefreshing: false,
      editForm: {
        opening: null,
        title: "",
        description: "",
        events: [
          { time: "12:00:00", type: "ouverture" },
          { time: "18:00:00", type: "fermeture" }
        ]
      },
      signalementForm: {
        linkedObjectSelection: null,
        commentaire: null,
        disable: false
      },
      adhesionTypes: [
        {
          value: "SAISON_SIMPLE",
          text: "Adhesion saison (individuelle)"
        },
        {
          value: "SAISON_FAMILLE",
          text: "Adhesion famille"
        },
        {
          value: "JOURNEE",
          text: "Adhesion journee"
        }
      ],
      paymentTypes: [
        { value: "LIQUIDE", text: "Liquide" },
        { value: "VIREMENT", text: "Virement" },
        { value: "CHEQUE", text: "Cheque" },
        { value: "PAYSSO", text: "Payasso" }
      ],
      genderOptions: [
        { value: "", text: "Selectionner une option" },
        { value: "home", text: "Homme" },
        { value: "femme", text: "Femme" },
        { value: "ne souhaite pas répondre", text: "Ne souhaite pas repondre" }
      ],
      reduiteReasons: [
        { value: "HANDICAP", text: "Situation de handicap" },
        { value: "ETUDIANT", text: "Etudiant" },
        { value: "CHOMAGE", text: "Chomeur" },
        { value: "MINEUR", text: "Mineur" }
      ],
      eventTypes: [
        { value: "ouverture", text: "Ouverture" },
        { value: "fermeture", text: "Fermeture" }
      ],
      confirmModalVisible: false,
      registrants: [],
      preregistrants: [],
      validatePreregLoadingId: null,
      removePreregLoadingId: null,
      editRegistrantModalVisible: false,
      editRegistrantTarget: null,
      editRegistrantForm: {
        harnais: false,
        combi: false,
        commentaire: "",
        covoit: 0
      },
      addSailMode: false,
      addBoardMode: false,
      addUsedGearLoading: false,
      removeParticipantLoadingId: null,
      gearInfoModalVisible: false,
      gearInfoItem: null,
      gearInfoType: "",
      reportModalVisible: false,
      reportTarget: null,
      signalementTargetOptions: [],
      signalementTargetMap: {},
      addUserForm: {
        ...buildAddUserForm()
      },
      addUserLoading: false,
      addUserCreateLoading: false,
      addUserCreateAdhesionLoading: false,
      removeUsedGearLoadingKey: null,
      returnGearModalVisible: false,
      returnGearTarget: null,
      returnGearConfirming: false,
      returnGearConfirmed: false,
      eventLocalKeySeed: 0,
      shareForm: {
        selectedUser: null
      }
    };
  },
  computed: {
    canCreateUser() {
      const create = this.addUserForm.create;
      return !!(
        create.name &&
        create.surname &&
        create.bornAt &&
        create.gender &&
        create.phoneNumber &&
        create.email &&
        create.reglementConsent === true
      );
    },
    reglementUrl() {
      return (axios.defaults.baseURL || '') + '/app-settings/reglement';
    },
    canAddUser() {
      return !!(this.addUserForm.selectedUser && this.addUserForm.selectedUser.id && this.addUserForm.hasValidAdhesion);
    },
    isCarpoolFilled() {
      const value = this.addUserForm.carpoolCount;
      if (value === "" || value === null || value === undefined) return false;
      const count = Number(value);
      return Number.isFinite(count) && count >= 0;
    },
    currentUserId() {
      const user = session.user;
      if (!user) return null;
      return user.id || user._id || null;
    },
    editSailsUsedItems() {
      return this.buildGearUsedItems(
        this.editRegistrantTarget && this.editRegistrantTarget.sailsUsed,
        "sail"
      );
    },
    editBoardsUsedItems() {
      return this.buildGearUsedItems(
        this.editRegistrantTarget && this.editRegistrantTarget.boardsUsed,
        "board"
      );
    },
  },
  mounted() {
    const user = session.user;
    if (!user || !["ouvreur", "admin"].includes(user.role)) {
      this.$router.replace("/");
      return;
    }
    this.fetchOpening();
    this.startAutoRefresh();
  },
  beforeDestroy() {
    this.stopAutoRefresh();
  },
  methods: {
    async createUserAccount() {
      if (!this.canCreateUser) {
        this.$bvToast.toast("Completez les champs obligatoires et acceptez le reglement.", {
          title: "Formulaire incomplet",
          variant: "warning",
          solid: true
        });
        return;
      }
      if (this.addUserCreateLoading) return;

      this.addUserCreateLoading = true;
      try {
        const create = this.addUserForm.create;
        const email = create.email.trim().toLowerCase();
        const temporaryPassword = this.generateTemporaryPassword();

        await UserService.ouvreurCreateAccount({
          name: create.name,
          surname: create.surname,
          phoneNumber: create.phoneNumber,
          email: email,
          bornAt: create.bornAt,
          gender: create.gender,
          password: temporaryPassword,
          newsletter: !!create.newsletter,
          photoConsent: !!create.photoConsent,
          swimmingConsent: !!create.swimmingConsent,
          reglementConsent: !!create.reglementConsent
        });

        const users = await UserService.searchUsers({ search: email, limit: 8 });
        const createdUser = users.find(user => (user.email || "").toLowerCase() === email) || users[0] || null;

        if (createdUser && createdUser.id) {
          this.addUserForm.selectedUser = createdUser;
          this.checkUserAdhesion(createdUser);
        }

        this.resetCreateUserForm();
        this.$bvToast.toast("Compte cree. Un email de definition de mot de passe a ete envoye.", {
          title: "Compte utilisateur cree",
          variant: "success",
          solid: true
        });
      } catch (error) {
        this.$bvToast.toast(error.message || "Impossible de créer le compte utilisateur.", {
          title: "Erreur",
          variant: "danger",
          solid: true
        });
      } finally {
        this.addUserCreateLoading = false;
      }
    },
    generateTemporaryPassword() {
      return `tmp-${Date.now()}-${Math.random().toString(36).slice(2, 12)}-A1!`;
    },
    resetCreateUserForm() {
      this.addUserForm.create = buildCreateUserForm();
    },
    formatTimeOnly(value) {
      const time = new Date(value);
      if (Number.isNaN(time.getTime())) {
        return null;
      }
      return time.toLocaleTimeString("fr-FR", {
        hour: "2-digit",
        minute: "2-digit",
        second: "2-digit",
        timeZone: "Europe/Paris",
        hour12: false,
      });
    },
    getEventCreatorLabel(event) {
      if (!event || !event.user) return "Non defini";
      const name = [event.user.name, event.user.surname].filter(Boolean).join(" ").trim();
      if (name) return name;
      return event.user.email || "Non defini";
    },
    getEventUserId(user) {
      if (!user) return null;
      if (typeof user === "string" || typeof user === "number") return user;
      return user.id || user._id || null;
    },
    canCurrentUserEditEvent(event) {
      if (!event) return false;
      if (!event._id) return true;
      const creatorId = this.getEventUserId(event.user);
      if (!creatorId || !this.currentUserId) return false;
      return String(creatorId) === String(this.currentUserId);
    },
    async fetchOpening({ silent = false } = {}) {
      const token = this.$route.params.token;
      if (!token) {
        if (!silent) {
          this.$bvToast.toast("Ouverture introuvable.", {
            title: "Erreur",
            variant: "danger",
            solid: true
          });
        }
        return;
      }
      this.isRefreshing = true;
      try {
        const res = await OpeningService.getById(token);
        const opening = res.data || {};
        const previousOpening = this.opening;
        this.opening = opening;

        const editFormDirty = silent && this.isEditFormDirty(previousOpening);
        if (!editFormDirty) {
          this.editForm.title = opening.title || "";
          this.editForm.description = opening.description || "";
          if (Array.isArray(opening.openingEvents) && opening.openingEvents.length) {
            this.editForm.events = opening.openingEvents.map(event => ({
              _id: event._id,
              time: this.formatTimeOnly(event.time) || "00:00:00",
              type: event.type,
              user: event.user || null
            }));
          }
        }

        this.registrants = opening.participants;
        this.preregistrants = opening.preregistrations || [];

      } catch (error) {
        if (!silent) {
          this.$bvToast.toast(error.message || "Impossible de recuperer l'ouverture.", {
            title: "Erreur",
            variant: "danger",
            solid: true
          });
        }
      } finally {
        this.isRefreshing = false;
        this.secondsUntilRefresh = Math.floor(this.refreshIntervalMs / 1000);
      }
    },
    isEditFormDirty(previousOpening) {
      if (!previousOpening) return false;
      if ((this.editForm.title || "") !== (previousOpening.title || "")) return true;
      if ((this.editForm.description || "") !== (previousOpening.description || "")) return true;
      const originals = previousOpening.openingEvents || [];
      if (this.editForm.events.length !== originals.length) return true;
      const originalById = new Map(originals.map(e => [String(e._id), e]));
      for (const local of this.editForm.events) {
        if (!local._id) return true;
        const orig = originalById.get(String(local._id));
        if (!orig) return true;
        if (orig.type !== local.type) return true;
        if (this.formatTimeOnly(orig.time) !== local.time) return true;
      }
      return false;
    },
    async manualRefresh() {
      if (this.isRefreshing) return;
      await this.fetchOpening({ silent: true });
      this.startAutoRefresh();
    },
    startAutoRefresh() {
      this.stopAutoRefresh();
      this.secondsUntilRefresh = Math.floor(this.refreshIntervalMs / 1000);
      this.refreshIntervalId = setInterval(() => {
        if (document.visibilityState === "hidden") return;
        this.fetchOpening({ silent: true });
      }, this.refreshIntervalMs);
      this.countdownIntervalId = setInterval(() => {
        if (document.visibilityState === "hidden") return;
        if (this.secondsUntilRefresh > 0) this.secondsUntilRefresh -= 1;
      }, 1000);
      this.visibilityHandler = () => {
        if (document.visibilityState === "visible") {
          this.fetchOpening({ silent: true });
        }
      };
      document.addEventListener("visibilitychange", this.visibilityHandler);
    },
    stopAutoRefresh() {
      if (this.refreshIntervalId) {
        clearInterval(this.refreshIntervalId);
        this.refreshIntervalId = null;
      }
      if (this.countdownIntervalId) {
        clearInterval(this.countdownIntervalId);
        this.countdownIntervalId = null;
      }
      if (this.visibilityHandler) {
        document.removeEventListener("visibilitychange", this.visibilityHandler);
        this.visibilityHandler = null;
      }
    },
    openConfirmModal() {
      this.confirmModalVisible = true;
    },
    openEditRegistrantModal(registrant) {
      if (!registrant) return;
      this.editRegistrantTarget = registrant;
      const covoitRaw = Number.parseInt(registrant.covoit, 10);
      this.editRegistrantForm = {
        harnais: !!registrant.harnais,
        combi: !!registrant.combi,
        commentaire: registrant.commentaire || "",
        covoit: Number.isFinite(covoitRaw) ? Math.min(Math.max(covoitRaw, 0), 10) : 0
      };
      this.addSailMode = false;
      this.addBoardMode = false;
      this.editRegistrantModalVisible = true;
    },
    closeEditRegistrantModal() {
      this.editRegistrantModalVisible = false;
      this.editRegistrantTarget = null;
      this.addSailMode = false;
      this.addBoardMode = false;
      this.addUsedGearLoading = false;
    },
    async applyRegistrantEdition() {
      if (!this.editRegistrantTarget) {
        this.$bvToast.toast("Aucun inscrit selectionne.", {
          title: "Erreur",
          variant: "danger",
          solid: true
        });
        this.editRegistrantModalVisible = false;
        return;
      }

      const openingId = this.opening && (this.opening.id || this.opening._id);
      const participantId = this.editRegistrantTarget._id;
      const covoitRaw = Number.parseInt(this.editRegistrantForm.covoit, 10);
      const payload = {
        harnais: !!this.editRegistrantForm.harnais,
        combi: !!this.editRegistrantForm.combi,
        commentaire: this.editRegistrantForm.commentaire || "",
        covoit: Number.isFinite(covoitRaw) ? Math.min(Math.max(covoitRaw, 0), 10) : 0
      };

      try {
        await OpeningService.updateParticipant(openingId, participantId, payload);
        this.syncRegistrantState(this.editRegistrantTarget, payload);
        this.editRegistrantModalVisible = false;
        this.$bvToast.toast("L'inscrit a ete mis a jour.", {
          title: "Mise a jour",
          variant: "success",
          solid: true
        });
      } catch (error) {
        this.$bvToast.toast(error.message || "Impossible de mettre a jour l'inscrit.", {
          title: "Erreur",
          variant: "danger",
          solid: true
        });
      }
    },
    async onAddSailSelected(sail) {
      if (!sail || this.addUsedGearLoading || !this.editRegistrantTarget) return;
      const openingId = this.opening && (this.opening.id || this.opening._id);
      const participantId = this.editRegistrantTarget.id || this.editRegistrantTarget._id;
      const sailId = this.getGearId(sail);
      if (!openingId || !participantId || !sailId) return;

      this.addUsedGearLoading = true;
      try {
        await OpeningService.addParticipantSailUsed(openingId, participantId, {
          sailId,
          setCurrent: true
        });
        const nextSailsUsed = this.appendGearHistory(
          this.editRegistrantTarget.sailsUsed,
          sail
        );
        this.syncRegistrantState(this.editRegistrantTarget, {
          sail,
          sailsUsed: nextSailsUsed
        });
        this.addSailMode = false;
      } catch (error) {
        this.$bvToast.toast(error.message || "Impossible d'ajouter la voile.", {
          title: "Erreur",
          variant: "danger",
          solid: true
        });
      } finally {
        this.addUsedGearLoading = false;
      }
    },
    async onAddBoardSelected(board) {
      if (!board || this.addUsedGearLoading || !this.editRegistrantTarget) return;
      const openingId = this.opening && (this.opening.id || this.opening._id);
      const participantId = this.editRegistrantTarget.id || this.editRegistrantTarget._id;
      const boardId = this.getGearId(board);
      if (!openingId || !participantId || !boardId) return;

      this.addUsedGearLoading = true;
      try {
        await OpeningService.addParticipantBoardUsed(openingId, participantId, {
          boardId,
          setCurrent: true
        });
        const nextBoardsUsed = this.appendGearHistory(
          this.editRegistrantTarget.boardsUsed,
          board
        );
        this.syncRegistrantState(this.editRegistrantTarget, {
          board,
          boardsUsed: nextBoardsUsed
        });
        this.addBoardMode = false;
      } catch (error) {
        this.$bvToast.toast(error.message || "Impossible d'ajouter la planche.", {
          title: "Erreur",
          variant: "danger",
          solid: true
        });
      } finally {
        this.addUsedGearLoading = false;
      }
    },
    handleReturnedChange(registrant, value) {
      if (!value) return;
      this.returnGearTarget = registrant;
      this.returnGearConfirming = false;
      this.returnGearConfirmed = false;
      this.returnGearModalVisible = true;
    },
    cancelReturnGear() {
      this.returnGearModalVisible = false;
    },
    onReturnGearModalHidden() {
      if (this.returnGearTarget && !this.returnGearConfirmed && this.returnGearTarget.returned) {
        this.returnGearTarget.returned = false;
      }
      this.returnGearTarget = null;
      this.returnGearConfirming = false;
      this.returnGearConfirmed = false;
    },
    async confirmReturnGear() {
      if (!this.returnGearTarget || this.returnGearConfirming) return;
      this.returnGearConfirming = true;
      try {
        await this.updateCheckStatus(this.returnGearTarget, "returned", true);
        this.returnGearConfirmed = true;
        this.returnGearModalVisible = false;
      } finally {
        this.returnGearConfirming = false;
      }
    },
    async updateCheckStatus(registrant, field, value) {
      const openingId = this.opening && (this.opening.id || this.opening._id);
      const participantId = registrant._id;
      if (!openingId || !participantId) return;
      try {
        await OpeningService.updateParticipant(openingId, participantId, { [field]: value });
      } catch (error) {
        registrant[field] = !value;
        this.$bvToast.toast(error.message || "Impossible de mettre a jour.", {
          title: "Erreur",
          variant: "danger",
          solid: true
        });
      }
    },
    getBoardName(board) {
      return board ? board.brand : "-";
    },
    gearPrimaryLabel(item, type) {
      if (!item) return "-";
      const fullName = item.full_name || "";
      if (type === "sail") {
        const parts = [];
        if (item.guc_id) parts.push(item.guc_id);
        if (fullName) parts.push(fullName);
        return parts.length ? parts.join(" · ") : "-";
      }
      const parts = [];
      if (item.brand) parts.push(item.brand);
      if (fullName) parts.push(fullName);
      return parts.length ? parts.join(" · ") : "-";
    },
    gearSecondaryLabel(item, type) {
      if (!item) return "";
      if (type === "sail") {
        const parts = [];
        if (item.brand) parts.push(item.brand);
        if (typeof item.size === "number") parts.push(`${item.size} m²`);
        return parts.join(" · ");
      }
      const parts = [];
      if (typeof item.volume === "number") parts.push(`${item.volume} L`);
      return parts.join(" · ");
    },
    openGearInfoModal(item, type) {
      if (!item) return;
      this.gearInfoItem = item;
      this.gearInfoType = type || "matos";
      this.gearInfoModalVisible = true;
    },
    closeGearInfoModal() {
      this.gearInfoModalVisible = false;
      this.gearInfoItem = null;
      this.gearInfoType = "";
    },
    gearInfoFields(item) {
      if (!item) return [];
      const fmt = v => (v === null || v === undefined || v === "") ? "-" : String(v);
      const dim = v => (v === null || v === undefined || v === "") ? "-" : `${v} cm`;

      if (this.gearInfoType === "Flotteur") {
        const vol = (item.volume !== null && item.volume !== undefined && item.volume !== "") ? `${item.volume} L` : "-";
        return [
          { key: "full_name", icon: "tag",           label: "Nom",          value: fmt(item.full_name) },
          { key: "volume",    icon: "droplet-half",  label: "Volume",       value: vol },
          { key: "foilable",  icon: "wind",          label: "Foilable",     value: item.foilable ? "Oui" : "Non" },
          { key: "storage",   icon: "archive",       label: "Rangement",    value: fmt(item.storage) },
          { key: "comments",  icon: "chat-left-text",label: "Commentaires", value: fmt(item.comments) },
        ];
      }

      const luff = parseFloat(item.luff);
      const mastLen = parseFloat(item.rec_mast_length);
      const extension = (!isNaN(luff) && !isNaN(mastLen)) ? luff - mastLen : null;
      const size = (item.size !== null && item.size !== undefined && item.size !== "") ? `${item.size} m²` : "-";
      return [
        { key: "full_name",       icon: "tag",              label: "Nom",          value: fmt(item.full_name) },
        { key: "brand",           icon: "shop",             label: "Marque",       value: fmt(item.brand) },
        { key: "size",            icon: "rulers",           label: "Taille",       value: size },
        { key: "guc_id",          icon: "hash",             label: "ID GUC",       value: fmt(item.guc_id) },
        { key: "luff",            icon: "arrow-bar-up",     label: "Guindant",     value: dim(item.luff) },
        { key: "boom",            icon: "arrows-expand",    label: "Boom",         value: dim(item.boom) },
        { key: "rec_mast_length", icon: "bar-chart-line",   label: "Longueur mât", value: dim(item.rec_mast_length) },
        { key: "rec_mast_curve",  icon: "bezier",           label: "Courbe mât",   value: dim(item.rec_mast_curve) },
        { key: "rec_mast_type",   icon: "list-ul",          label: "Type mât",     value: fmt(item.rec_mast_type) },
        { key: "extension",       icon: "plus-slash-minus", label: "Rallonge",     value: extension !== null ? `${extension} cm` : "-" },
        { key: "comments",        icon: "chat-left-text",   label: "Commentaires", value: fmt(item.comments) },
      ];
    },
    getGearId(gear) {
      if (!gear || !gear._id) return null;
      return gear._id.toString();
    },
    syncRegistrantState(registrant, partial) {
      const targetId = registrant && (registrant.id || registrant._id);
      if (!targetId) return;
      // La cible peut être un inscrit confirmé ou un préinscrit : on met à jour
      // la liste qui le contient (la modale d'édition est partagée entre les deux).
      const listKey = ["registrants", "preregistrants"].find(key =>
        this[key].some(item => {
          const itemId = item && (item.id || item._id);
          return itemId && itemId.toString() === targetId.toString();
        })
      );
      if (!listKey) return;
      const list = this[listKey];
      const index = list.findIndex(item => {
        const itemId = item && (item.id || item._id);
        return itemId && itemId.toString() === targetId.toString();
      });
      if (index === -1) return;
      this.$set(list, index, {
        ...list[index],
        ...partial
      });
      const updated = list[index];
      const sameId = (target) => target && (target.id || target._id) && (target.id || target._id).toString() === targetId.toString();
      if (sameId(this.editRegistrantTarget)) {
        this.editRegistrantTarget = updated;
      }
      if (sameId(this.returnGearTarget)) {
        this.returnGearTarget = updated;
      }
    },
    async removeSailUsed(registrant, sailId) {
      if (!registrant || !sailId) return;
      const openingId = this.opening && (this.opening.id || this.opening._id);
      const participantId = registrant.id || registrant._id;
      if (!openingId || !participantId) return;

      const loadingKey = `sail-${sailId}`;
      if (this.removeUsedGearLoadingKey) return;
      this.removeUsedGearLoadingKey = loadingKey;
      try {
        await OpeningService.removeParticipantSailUsed(openingId, participantId, sailId);
        const currentSailId = this.getGearId(registrant.sail);
        const nextSailsUsed = (registrant.sailsUsed || []).filter(
          sail => this.getGearId(sail) !== sailId
        );
        const nextSail =
          currentSailId === sailId
            ? nextSailsUsed[nextSailsUsed.length - 1] || null
            : registrant.sail;

        this.syncRegistrantState(registrant, {
          sail: nextSail,
          sailsUsed: nextSailsUsed
        });
      } catch (error) {
        this.$bvToast.toast(error.message || "Impossible de supprimer la voile utilisee.", {
          title: "Erreur",
          variant: "danger",
          solid: true
        });
      } finally {
        this.removeUsedGearLoadingKey = null;
      }
    },
    async removeBoardUsed(registrant, boardId) {
      if (!registrant || !boardId) return;
      const openingId = this.opening && (this.opening.id || this.opening._id);
      const participantId = registrant.id || registrant._id;
      if (!openingId || !participantId) return;

      const loadingKey = `board-${boardId}`;
      if (this.removeUsedGearLoadingKey) return;
      this.removeUsedGearLoadingKey = loadingKey;
      try {
        await OpeningService.removeParticipantBoardUsed(openingId, participantId, boardId);
        const currentBoardId = this.getGearId(registrant.board);
        const nextBoardsUsed = (registrant.boardsUsed || []).filter(
          board => this.getGearId(board) !== boardId
        );
        const nextBoard =
          currentBoardId === boardId
            ? nextBoardsUsed[nextBoardsUsed.length - 1] || null
            : registrant.board;

        this.syncRegistrantState(registrant, {
          board: nextBoard,
          boardsUsed: nextBoardsUsed
        });
      } catch (error) {
        this.$bvToast.toast(error.message || "Impossible de supprimer la planche utilisee.", {
          title: "Erreur",
          variant: "danger",
          solid: true
        });
      } finally {
        this.removeUsedGearLoadingKey = null;
      }
    },
    appendGearHistory(history, ...gears) {
      const list = Array.isArray(history) ? [...history] : [];
      const seen = new Set(list.map(item => this.getGearId(item)).filter(Boolean));
      gears.forEach(gear => {
        const id = this.getGearId(gear);
        if (!id || seen.has(id)) return;
        list.push(gear);
        seen.add(id);
      });
      return list;
    },
    buildGearUsedItems(items, type) {
      if (!Array.isArray(items) || items.length === 0) return [];
      const seen = new Set();
      const result = [];
      for (const item of items) {
        const id = this.getGearId(item);
        if (!id || seen.has(id)) continue;
        seen.add(id);
        result.push({
          id,
          item,
          primary: this.gearPrimaryLabel(item, type),
          secondary: this.gearSecondaryLabel(item, type),
          rigged: type === "sail" ? !!item.rigged : null
        });
      }
      return result;
    },
    getSailsUsedItems(sailsUsed) {
      if (!Array.isArray(sailsUsed) || sailsUsed.length === 0) return [];
      return sailsUsed
        .map(sail => ({
          id: this.getGearId(sail),
          label: sail.guc_id || sail.full_name
        }))
        .filter(item => item.id && item.label)
        .filter((item, index, arr) => arr.findIndex(i => i.id === item.id) === index);
    },
    getBoardsUsedItems(boardsUsed) {
      if (!Array.isArray(boardsUsed) || boardsUsed.length === 0) return [];
      return boardsUsed
        .map(board => ({
          id: this.getGearId(board),
          label: board.full_name
        }))
        .filter(item => item.id && item.label)
        .filter((item, index, arr) => arr.findIndex(i => i.id === item.id) === index);
    },
    getSailId(sail) {
      if (!sail) return "-";
      return sail.guc_id || sail.id || "-";
    },
    buildSignalementTargetOptions(registrant) {
      const options = [];
      const map = {};
      if (!registrant || !registrant.user || !registrant.user._id) {
        return { options, map };
      }

      const userKey = `User:${registrant.user._id}`;
      options.push({
        value: userKey,
        text: `Adherent - ${registrant.user.name} ${registrant.user.surname}`
      });
      map[userKey] = {
        linkedObjectType: "User",
        linkedObjectId: registrant.user._id.toString()
      };

      this.getSailsUsedItems(registrant.sailsUsed).forEach(item => {
        const key = `Sail:${item.id}`;
        options.push({
          value: key,
          text: `Voile - ${item.label}`
        });
        map[key] = {
          linkedObjectType: "Sail",
          linkedObjectId: item.id
        };
      });

      this.getBoardsUsedItems(registrant.boardsUsed).forEach(item => {
        const key = `Board:${item.id}`;
        options.push({
          value: key,
          text: `Flotteur - ${item.label}`
        });
        map[key] = {
          linkedObjectType: "Board",
          linkedObjectId: item.id
        };
      });

      return { options, map };
    },
    async sendSignalement() {

      const commentaire = (this.signalementForm.commentaire || "").trim();
      if (!commentaire) {
        this.$bvToast.toast("Ajoutez un commentaire pour envoyer le signalement.", {
          title: "Erreur",
          variant: "danger",
          solid: true
        });
        return;
      }

      const selectedKey = this.signalementForm.linkedObjectSelection;
      const selectedTarget = selectedKey ? this.signalementTargetMap[selectedKey] : null;
      if (!selectedTarget) {
        this.$bvToast.toast("Selectionnez un element a signaler.", {
          title: "Erreur",
          variant: "danger",
          solid: true
        });
        return;
      }

      const payload = {
        commentaire,
        linkedObjectType: selectedTarget.linkedObjectType,
        linkedObjectId: selectedTarget.linkedObjectId
      };
      if (selectedTarget.linkedObjectType !== "User" && this.reportTarget && this.reportTarget.user && this.reportTarget.user._id) {
        payload.concernedUserId = this.reportTarget.user._id;
      }
      if (selectedTarget.linkedObjectType === "Sail" || selectedTarget.linkedObjectType === "Board") {
        payload.disable = !!this.signalementForm.disable;
      }

      try {
        await SignalementService.create(payload);
        this.$bvToast.toast("Signalement envoye.", {
          title: "Signalement",
          variant: "success",
          solid: true
        });
        this.signalementForm = {
          linkedObjectSelection: null,
          commentaire: null,
          disable: false
        };
        this.signalementTargetOptions = [];
        this.signalementTargetMap = {};
        this.reportTarget = null;
        this.reportModalVisible = false;
      } catch (error) {
        this.$bvToast.toast(error.message || "Impossible d'envoyer le signalement.", {
          title: "Erreur",
          variant: "danger",
          solid: true
        });
      }
    },
    removeSelectedUser() {
      this.addUserForm.selectedUser = null;
      this.addUserForm.hasValidAdhesion = false;
      this.addUserForm.carpoolDetected = null;
      this.addUserForm.carpoolCount = "";
      this.addUserCreateAdhesionLoading = false;
    },
    openReportModal(registrant) {
      const { options, map } = this.buildSignalementTargetOptions(registrant);
      this.reportTarget = registrant || null;
      this.signalementTargetOptions = options;
      this.signalementTargetMap = map;
      this.signalementForm = {
        linkedObjectSelection: options.length ? options[0].value : null,
        commentaire: null,
        disable: false
      };
      this.reportModalVisible = true;
    },
    closeReportModal() {
      this.reportModalVisible = false;
      this.signalementTargetOptions = [];
      this.signalementTargetMap = {};
    },
    handleShareUserSelected(user) {
      if (!user || !user.id) return;
      this.shareForm.selectedUser = user;
    },
    covoitCountFor(entry) {
      // Le covoiturage réel vit dans les offres opening.covoits[] (rejoint/créé
      // via le portail). On dérive donc le nombre de personnes du covoit de
      // l'utilisateur plutôt que du champ déclaré (qui n'est pas alimenté lors
      // d'une préinscription). À défaut d'offre, on retombe sur la valeur déclarée.
      const userId = entry && entry.user ? (entry.user._id || entry.user.id) : null;
      const covoits = this.opening && Array.isArray(this.opening.covoits) ? this.opening.covoits : [];
      const toId = v => v && (typeof v === 'object' ? (v._id || v.id) : v);
      const matchId = v => userId && toId(v) && toId(v).toString() === userId.toString();

      const covoit = covoits.find(c =>
        matchId(c.driver) || (Array.isArray(c.passenger) && c.passenger.some(p => matchId(p)))
      );
      if (covoit) {
        return (Array.isArray(covoit.passenger) ? covoit.passenger.length : 0) + 1;
      }

      const declared = Number.parseInt(entry && entry.covoit, 10);
      return Number.isFinite(declared) ? declared : 0;
    },
    handleAddUserSelected(user) {
      if (!user || !user.id) return;
      this.addUserForm.selectedUser = user;

      const covoits = this.opening && Array.isArray(this.opening.covoits) ? this.opening.covoits : [];
      const toId = v => v && (typeof v === 'object' ? (v._id || v.id) : v);
      const matchId = (v) => toId(v) && toId(v).toString() === user.id.toString();

      const driverCovoit = covoits.find(c => matchId(c.driver));
      const passengerCovoit = !driverCovoit && covoits.find(c =>
        Array.isArray(c.passenger) && c.passenger.some(p => matchId(p))
      );

      if (driverCovoit) {
        this.addUserForm.carpoolDetected = { covoit: driverCovoit, role: 'driver' };
        this.addUserForm.carpoolCount = (Array.isArray(driverCovoit.passenger) ? driverCovoit.passenger.length : 0) + 1;
      } else if (passengerCovoit) {
        this.addUserForm.carpoolDetected = { covoit: passengerCovoit, role: 'passenger' };
        this.addUserForm.carpoolCount = (Array.isArray(passengerCovoit.passenger) ? passengerCovoit.passenger.length : 0) + 1;
      }

      this.checkUserAdhesion(user);
    },
    checkUserAdhesion(user) {
      console.log("Checking adhesion for user:", user);
      if (!user.id) return;

      try {
        AdhesionService.checkValid(user.id)
          .then(res => {
            this.addUserForm.hasValidAdhesion = res.data && res.data.hasValidAdhesion === true;
          })
          .catch(() => {
            this.addUserForm.hasValidAdhesion = false;
          });
      } catch (error) {
        console.error("Error checking adhesion:", error);
        this.addUserForm.hasValidAdhesion = false;
      }
    },
    resetAddUserForm() {
      this.addUserForm = buildAddUserForm();
      this.addUserCreateLoading = false;
      this.addUserCreateAdhesionLoading = false;
    },
    async createAdhesionForSelectedUser() {
      const selectedUser = this.addUserForm.selectedUser;
      if (!selectedUser || !selectedUser.id) {
        this.$bvToast.toast("Selectionnez un utilisateur avant de créer une adhesion.", {
          title: "Utilisateur requis",
          variant: "warning",
          solid: true
        });
        return;
      }
      if (this.addUserCreateAdhesionLoading) return;

      this.addUserCreateAdhesionLoading = true;
      try {
        const payload = {
          adherentId: selectedUser.id,
          adhesion_type: this.addUserForm.adhesion.type,
          paiement_type: this.addUserForm.adhesion.payment,
          adhesion_reduite: !!this.addUserForm.adhesion.reduite,
          reduite_reason: this.addUserForm.adhesion.reduiteReason || null
        };
        await AdhesionService.addMembership(payload);
        this.checkUserAdhesion(selectedUser);
        this.$bvToast.toast("Adhesion creee avec succes.", {
          title: "Adhesion",
          variant: "success",
          solid: true
        });
      } catch (error) {
        this.$bvToast.toast(error.message || "Impossible de créer l'adhesion.", {
          title: "Erreur",
          variant: "danger",
          solid: true
        });
      } finally {
        this.addUserCreateAdhesionLoading = false;
      }
    },
    async addParticipant() {
      if (!this.opening) {
        this.$bvToast.toast("Ouverture introuvable.", {
          title: "Erreur",
          variant: "danger",
          solid: true
        });
        return;
      }

      const selectedUser = this.addUserForm.selectedUser;
      if (!selectedUser || !selectedUser.id) {
        this.$bvToast.toast("Selectionnez un utilisateur avant de continuer.", {
          title: "Utilisateur requis",
          variant: "warning",
          solid: true
        });
        return;
      }

      const alreadyRegistered = this.registrants.some(registrant => {
        const userId = registrant && registrant.user
          ? registrant.user.id || registrant.user._id
          : null;
        return userId && userId === selectedUser.id;
      });
      if (alreadyRegistered) {
        this.$bvToast.toast("Cet utilisateur est deja inscrit a l'ouverture.", {
          title: "Utilisateur deja inscrit",
          variant: "info",
          solid: true
        });
        return;
      }

      if (this.addUserLoading) return;
      this.addUserLoading = true;

      const notes = (this.addUserForm.comment || "").trim();
      const carpoolCount = parseInt(this.addUserForm.carpoolCount, 10);
      const payload = {
        userId: selectedUser.id,
        notes: notes || undefined,
        carpool: Number.isFinite(carpoolCount) ? carpoolCount : 0,
        gear: {
          harnais: !!this.addUserForm.harness,
          combi: !!this.addUserForm.wetsuit,
          sail: this.addUserForm.sail,
          board: this.addUserForm.board
        }
      };

      const token = this.$route.params.token;
      try {
        const res = await OpeningService.addParticipant(token, payload);
        const participant = res.data.participant;
        if (participant) {
          this.registrants.push(participant);
        } else {
          await this.fetchOpening();
        }
        this.resetAddUserForm();
        this.$bvToast.toast("Utilisateur ajoute a l'ouverture.", {
          title: "Participant ajoute",
          variant: "success",
          solid: true
        });
      } catch (error) {
        this.$bvToast.toast(error.message || "Impossible d'ajouter l'utilisateur.", {
          title: "Erreur",
          variant: "danger",
          solid: true
        });
      } finally {
        this.addUserLoading = false;
      }
    },
    async removeParticipant(registrant) {
      if (!registrant) return;
      const participantId = registrant.id || registrant._id;
      if (!participantId) {
        this.$bvToast.toast("Participant introuvable.", {
          title: "Erreur",
          variant: "danger",
          solid: true
        });
        return;
      }

      if (!confirm("Supprimer cet inscrit ?")) return;
      if (this.removeParticipantLoadingId === participantId) return;
      this.removeParticipantLoadingId = participantId;

      const token = this.$route.params.token;
      try {
        await OpeningService.removeParticipant(token, participantId);
        this.registrants = this.registrants.filter(item => {
          const itemId = item && (item.id || item._id);
          return itemId !== participantId;
        });
        this.$bvToast.toast("Participant supprimé.", {
          title: "Suppression",
          variant: "success",
          solid: true
        });
      } catch (error) {
        this.$bvToast.toast(error.message || "Impossible de supprimer le participant.", {
          title: "Erreur",
          variant: "danger",
          solid: true
        });
      } finally {
        if (this.removeParticipantLoadingId === participantId) {
          this.removeParticipantLoadingId = null;
        }
      }
    },
    async validatePreregistration(prereg) {
      if (!prereg) return;
      const preId = prereg.id || prereg._id;
      const openingId = this.opening && (this.opening.id || this.opening._id);
      if (!openingId || !preId) return;
      if (this.validatePreregLoadingId === preId) return;
      this.validatePreregLoadingId = preId;
      try {
        await OpeningService.validatePreregistration(openingId, preId);
        await this.fetchOpening({ silent: true });
        this.$bvToast.toast("Préinscription validée, le participant a été ajouté à la liste des inscrits.", {
          title: "Validation",
          variant: "success",
          solid: true
        });
      } catch (error) {
        this.$bvToast.toast(error.message || "Impossible de valider la préinscription.", {
          title: "Erreur",
          variant: "danger",
          solid: true
        });
      } finally {
        this.validatePreregLoadingId = null;
      }
    },
    async removePreregistration(prereg) {
      if (!prereg) return;
      const preId = prereg.id || prereg._id;
      if (!preId) return;
      if (!confirm("Supprimer cette préinscription ?")) return;
      const openingId = this.opening && (this.opening.id || this.opening._id);
      if (this.removePreregLoadingId === preId) return;
      this.removePreregLoadingId = preId;
      try {
        await OpeningService.removePreregistration(openingId, preId);
        this.preregistrants = this.preregistrants.filter(item => {
          const itemId = item && (item.id || item._id);
          return itemId !== preId;
        });
        this.$bvToast.toast("Préinscription supprimée.", {
          title: "Suppression",
          variant: "success",
          solid: true
        });
      } catch (error) {
        this.$bvToast.toast(error.message || "Impossible de supprimer la préinscription.", {
          title: "Erreur",
          variant: "danger",
          solid: true
        });
      } finally {
        if (this.removePreregLoadingId === preId) {
          this.removePreregLoadingId = null;
        }
      }
    },
    addEvent() {
      this.editForm.events.push({
        _localKey: `new-${++this.eventLocalKeySeed}`,
        time: "12:00:00",
        type: "ouverture",
        user: session.user || null
      });
    },
    removeEvent(index) {
      if (this.editForm.events.length <= 2) return;
      const event = this.editForm.events[index];
      if (!event) return;
      if (!this.canCurrentUserEditEvent(event)) return;
      this.editForm.events.splice(index, 1);
    },
    applyOpeningEvents(openingEvents) {
      this.editForm.events = (openingEvents || []).map(event => ({
        _id: event._id,
        time: this.formatTimeOnly(event.time) || "00:00:00",
        type: event.type,
        user: event.user || null
      }));
      if (this.opening) {
        this.opening.openingEvents = openingEvents;
      }
    },
    hasEventChanges() {
      const originals = (this.opening && this.opening.openingEvents) || [];
      if (this.editForm.events.length !== originals.length) return true;
      const originalById = new Map(originals.map(e => [String(e._id), e]));
      for (const local of this.editForm.events) {
        if (!local._id) return true;
        const orig = originalById.get(String(local._id));
        if (!orig) return true;
        if (orig.type !== local.type) return true;
        if (this.formatTimeOnly(orig.time) !== local.time) return true;
      }
      return false;
    },
    async updateOpeningInfo() {
      if (!this.opening) {
        this.$bvToast.toast("Ouverture introuvable.", {
          title: "Erreur",
          variant: "danger",
          solid: true
        });
        return;
      }

      const titleChanged = this.editForm.title != this.opening.title;
      const descriptionChanged = this.editForm.description != this.opening.description;
      const eventsChanged = this.hasEventChanges();

      if (!titleChanged && !descriptionChanged && !eventsChanged) {
        this.$bvToast.toast("Aucun changement.", {
          title: "Aucun changement",
          variant: "info",
          solid: true
        });
        this.confirmModalVisible = false;
        return;
      }

      const openingId = this.opening.id || this.opening._id;

      try {
        if (descriptionChanged) {
          await OpeningService.updateOpeningInfo(openingId, {
            description: this.editForm.description
          });
          this.opening.description = this.editForm.description;
        }

        if (eventsChanged) {
          const originals = this.opening.openingEvents || [];
          const originalById = new Map(originals.map(e => [String(e._id), e]));
          const localIds = new Set();

          const added = [];
          const modified = [];

          for (const local of this.editForm.events) {
            if (!local._id) {
              added.push({ type: local.type, time: local.time });
              continue;
            }
            localIds.add(String(local._id));
            const orig = originalById.get(String(local._id));
            if (!orig) continue;
            const typeChanged = orig.type !== local.type;
            const timeChanged = this.formatTimeOnly(orig.time) !== local.time;
            if (typeChanged || timeChanged) {
              modified.push({ _id: local._id, type: local.type, time: local.time });
            }
          }

          const removed = originals
            .filter(orig => !localIds.has(String(orig._id)))
            .map(orig => orig._id);

          if (added.length || modified.length || removed.length) {
            const res = await OpeningService.updateOpeningEvents(openingId, { added, modified, removed });
            if (res && res.data && Array.isArray(res.data.openingEvents)) {
              this.applyOpeningEvents(res.data.openingEvents);
            }
          }
        }

        this.$bvToast.toast("Les informations de l'ouverture ont ete mises a jour.", {
          title: "Ouverture mise a jour",
          variant: "success",
          solid: true
        });
      } catch (error) {
        this.$bvToast.toast(error.message || "Une erreur est survenue lors de la mise a jour de l'ouverture.", {
          title: "Erreur",
          variant: "danger",
          solid: true
        });
      } finally {
        this.confirmModalVisible = false;
      }
    }
  }
};
</script>

<style scoped>
.refresh-indicator {
  margin-bottom: 0.5rem;
  opacity: 0.7;
  font-size: 0.8rem;
}

.refresh-button {
  font-size: 0.8rem;
}

.collapse-toggle {
  cursor: pointer;
  user-select: none;
  margin-bottom: 0;
}

.collapse-toggle.not-collapsed {
  margin-bottom: 1rem;
}

.collapse-chevron {
  transition: transform 0.2s ease;
  color: #6c757d;
}

.collapse-toggle.not-collapsed .collapse-chevron {
  transform: rotate(180deg);
}

.section-title {
  font-size: 1rem;
  font-weight: 600;
  color: #374151;
  margin-bottom: 0.75rem;
}

/* --- Formulaire "Ajouter un utilisateur" --- */
.form-section {
  padding: 1.1rem 1.15rem;
  margin-bottom: 1rem;
  background: var(--color-surface-light, #f8f9fa);
  border: 1px solid var(--color-border-light, #e6eaee);
  border-radius: 0.75rem;
}

.form-section-heading {
  display: flex;
  align-items: center;
  gap: 0.55rem;
  margin-bottom: 0.85rem;
  font-size: 0.82rem;
  font-weight: 700;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  color: var(--color-guc-darkblue, #056d80);
}

.form-section-heading__icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 1.9rem;
  height: 1.9rem;
  border-radius: 0.5rem;
  background: var(--color-guc-lightblue, #cdecef);
  color: var(--color-guc-darkblue, #056d80);
  flex-shrink: 0;
}

.selected-user-card {
  display: flex;
  align-items: center;
  gap: 0.85rem;
  padding: 0.75rem 0.9rem;
  background: #ffffff;
  border: 1px solid var(--color-guc-blue, #9dd3dd);
  border-radius: 0.65rem;
}

.selected-user-card__avatar {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 2.6rem;
  height: 2.6rem;
  border-radius: 50%;
  background: var(--color-guc-darkblue, #056d80);
  color: #ffffff;
  flex-shrink: 0;
}

.add-user-actions {
  display: flex;
  justify-content: flex-end;
  padding-top: 0.5rem;
}

.equipment-options {
  display: flex;
  flex-wrap: wrap;
  gap: 0.6rem;
}

.equipment-option {
  display: inline-flex;
  align-items: center;
  gap: 0.55rem;
  margin: 0;
  padding: 0.55rem 0.9rem;
  background: #ffffff;
  border: 1px solid var(--color-border-light, #e6eaee);
  border-radius: 999px;
  cursor: pointer;
  user-select: none;
  transition: border-color 0.15s ease, background 0.15s ease, box-shadow 0.15s ease;
}

.equipment-option:hover {
  border-color: var(--color-guc-blue, #9dd3dd);
}

.equipment-option--active {
  background: var(--color-guc-lightblue, #cdecef);
  border-color: var(--color-guc-darkblue, #056d80);
  box-shadow: inset 0 0 0 1px var(--color-guc-darkblue, #056d80);
}

.equipment-option__input {
  position: absolute;
  opacity: 0;
  width: 0;
  height: 0;
}

.equipment-option__icon {
  width: 1.25rem;
  height: 1.25rem;
  color: var(--color-guc-darkblue, #056d80);
}

.equipment-option__label {
  font-weight: 600;
  color: var(--color-text-primary, #212529);
}

.equipment-option__state {
  color: #c4ccd4;
}

.equipment-option--active .equipment-option__state {
  color: var(--color-guc-darkblue, #056d80);
}

.required-asterisk {
  color: var(--color-guc-yellow, #ff914d);
  font-weight: 700;
}

.section-divider {
  border: 0;
  border-top: 1px solid #e5e7eb;
  margin: 0.5rem 0 0.35rem;
}

hr {
  margin: 0.25rem 0;
}

.manage-event-time-input {
  width: 150px;
}

.manage-event-type-input {
  width: 140px;
}

.participants-table {
  --participants-table-bg: #ffffff;
  --participants-table-header-bg: #ffffff;
}

.participants-table :deep(table) {
  background-color: var(--participants-table-bg);
}

.participants-table :deep(thead th) {
  background-color: var(--participants-table-header-bg);
}

.participant-row {
  cursor: pointer;
}

/* Aligne verticalement le contenu de chaque cellule (icônes harnais/combi,
   switches matos, boutons d'action) avec les colonnes Voile/Flotteur qui
   peuvent tenir sur deux lignes. */
.participants-table :deep(td),
.participants-table :deep(th) {
  vertical-align: middle;
}

.actions-group {
  white-space: nowrap;
}

.actions-group :deep(.btn) {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 2rem;
  border-color: color-mix(in srgb, var(--color-primary) 55%, white) !important;
}

.actions-group :deep(.btn:hover),
.actions-group :deep(.btn:focus) {
  border-color: color-mix(in srgb, var(--color-primary) 55%, white) !important;
}

.registrant-card {
  border: 1px solid #e5e7eb;
  border-left: 4px solid #d1d5db;
  cursor: pointer;
}

.registrant-card--success {
  border-left-color: #16a34a;
  background: #f0fdf4;
}

.registrant-card--warning {
  border-left-color: #d97706;
  background: #fffbeb;
}

.registrant-card--info {
  border-left-color: #6610f2;
  background: #ede7fb;
}

.preregistrant-row :deep(td) {
  background-color: #ede7fb;
  border-top: 1px solid #d8c9f7;
}

.preregistrant-row :deep(td:first-child) {
  box-shadow: inset 4px 0 0 #6610f2;
}

.registrant-meta__row {
  display: flex;
  justify-content: space-between;
  gap: 0.75rem;
  padding: 0.2rem 0;
}

.registrant-meta__label {
  color: #6b7280;
  font-size: 0.85rem;
}

.registrant-meta__value {
  font-weight: 600;
  text-align: right;
}

.registrant-flags {
  display: flex;
  align-items: center;
  font-size: 0.9rem;
}

.registrant-switches__row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0.25rem 0;
}

.registrant-switches__label {
  font-size: 0.9rem;
  color: #374151;
}

.registrant-actions-icons {
  display: inline-flex;
  align-items: center;
}

.card {
  border-radius: 0.8rem;
}

.gear-used-label {
  font-weight: 600;
  color: #374151;
  font-size: 0.9rem;
  margin-bottom: 0.4rem;
}

.gear-used-list {
  display: flex;
  flex-direction: column;
  gap: 0.4rem;
  margin-bottom: 0.5rem;
}

.gear-used-row {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.55rem 0.75rem;
  background: #f9fafb;
  border: 1px solid #e5e7eb;
  border-radius: 0.5rem;
  transition: border-color 0.15s ease;
}

.gear-used-row:hover {
  border-color: #d1d5db;
}

.gear-used-row__main {
  flex: 1;
  min-width: 0;
}

.gear-used-row__primary {
  font-weight: 600;
  color: #111827;
  line-height: 1.25;
  word-break: break-word;
}

.gear-used-row__secondary {
  font-size: 0.78rem;
  color: #6b7280;
  line-height: 1.25;
  margin-top: 0.1rem;
}

.gear-used-row__badge {
  flex-shrink: 0;
}

.gear-used-row__action {
  flex-shrink: 0;
}

.gear-used-empty {
  display: flex;
  align-items: center;
  padding: 0.6rem 0.75rem;
  border: 1px dashed #e5e7eb;
  border-radius: 0.5rem;
  color: #9ca3af;
  font-size: 0.85rem;
  background: #fafafa;
}

.gear-add-zone {
  padding: 0.75rem 0.75rem 0;
  background: #f3f4f6;
  border: 1px solid #e5e7eb;
  border-radius: 0.5rem;
}

.gear-add-button {
  border-radius: 0.5rem;
  font-weight: 500;
}

.carpool-edit {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  padding: 0.6rem 0.75rem;
  background: #f2ffef;
  border: 1px solid #bffed2;
  border-radius: 0.5rem;
}

.carpool-edit__icon {
  color: #636363;
  flex-shrink: 0;
}

.carpool-edit__label {
  flex: 1;
  font-weight: 500;
  color: #111827;
  line-height: 1.25;
}

.carpool-edit__input {
  flex-shrink: 0;
  min-width: 8rem;
}

.gear-info-row {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  padding: 0.55rem 0;
  border-bottom: 1px solid #f3f4f6;
}

.gear-info-row:last-child {
  border-bottom: 0;
}

.gear-info-row__icon {
  flex-shrink: 0;
  font-size: 1rem;
  color: #6b7280;
  width: 1.1rem;
}

.gear-info-row__content {
  flex: 1;
  min-width: 0;
}

.gear-info-row__label {
  font-size: 0.7rem;
  color: #9ca3af;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  line-height: 1.2;
}

.gear-info-row__value {
  font-size: 0.92rem;
  font-weight: 500;
  word-break: break-word;
  color: #111827;
}

@media (max-width: 576px) {
  .manage-event-time-input,
  .manage-event-type-input {
    width: 100%;
  }
}
</style>
